"use client";

import { useState } from "react";

import type { ConversationSource } from "~/conversations/types/conversation";
import { IconFile } from "~/common/components/icons/file";
import { MenuExpand } from "~/chat/components/menu-expand";
import { formatDateForResources } from "~/common/utils/date";
import { useActiveConversationId } from "~/conversations/hooks/use-active-conversation-id";
import { useGetConversationSources } from "~/conversations/queries/get-conversation-sources-query";

import { MenuItem } from "./menu-item";
import { sideNavStyle } from "./navigation.style";
import { NavigationSection } from "./navigation-section";

function getItemsCountLabel(count?: number) {
  return count && count > 0 ? `(${count})` : "";
}

function NavigationRight({ className }: { className?: string }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const conversationId = useActiveConversationId();
  const { data: sources } = useGetConversationSources({ conversationId });

  // TODO there is no useful links yet
  const showUsefulLinks = false;
  const usefulLinks: ConversationSource[] = [];

  // expand functionality is not needed if useful links are not rendered at all
  const showExpandButton = sources && showUsefulLinks;

  return (
    <aside className={sideNavStyle.container({ className })}>
      <div className="flex flex-col gap-16">
        <span className="p-8 text-body-2-emphasis text-text-primary">
          Related
        </span>

        <div className={sideNavStyle.navigationContent()}>
          <div className={sideNavStyle.navigationSections()}>
            <NavigationSection
              label={`Documents ${getItemsCountLabel(sources?.length)}`}
              items={sources}
              renderItem={(item) => (
                <li
                  key={item.id}
                  data-test="document"
                >
                  <MenuItem
                    href={item.url}
                    additionalInfo={formatDateForResources(item.updated_at)}
                    icon={<IconFile />}
                    target="_blank"
                  >
                    {item.title}
                  </MenuItem>
                </li>
              )}
              dataTestTag="found-documents-list"
            />

            {!!showExpandButton && (
              <MenuExpand
                onClick={() => setIsExpanded(!isExpanded)}
                isExpanded={isExpanded}
              />
            )}

            {!!showUsefulLinks && (
              <NavigationSection
                label={`Useful links ${getItemsCountLabel(usefulLinks?.length)}`}
                items={usefulLinks}
                renderItem={(item) => (
                  <li key={item.id}>
                    <MenuItem
                      href={item.url}
                      target="_blank"
                    >
                      {item.title}
                    </MenuItem>
                  </li>
                )}
                emptyLabel="No links yet..."
              />
            )}
          </div>
        </div>
      </div>
    </aside>
  );
}

export { NavigationRight };
